import React from "react";
import { createRoot } from "react-dom/client";
import { applyTheme } from "@cloudscape-design/components/theming";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import LoginPage from "./routes/LoginPage";
import {
  parseAuthQueryString,
  getToken,
  handleCode,
} from "./api/auth";

applyTheme({
  theme: {
    tokens: {
      colorBackgroundButtonPrimaryDefault: "#10b981",
      colorBackgroundButtonPrimaryHover: "#059669",
      colorBackgroundButtonPrimaryActive: "#047857",
      colorBackgroundButtonPrimaryDisabled: "#6ee7b7",
      colorTextButtonPrimaryDefault: "#ffffff",
      colorTextButtonPrimaryHover: "#ffffff",
      colorTextButtonPrimaryActive: "#ffffff",
    },
  },
});

const root = createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

(async () => {
  try {
    const tokenData = parseAuthQueryString();
    if (tokenData) await handleCode(tokenData);
    const token = await getToken();
    if (!token) {
      root.render(<LoginPage />);
      return;
    }
    renderApp();
  } catch (e) {
    console.error(e);
    root.render(<LoginPage />);
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();